import React from 'react'
import {JSONFetcher, formatCents, gaEvent, findApiV4Link} from 'shared'

export class Forwardings extends React.Component {
  state = { data: [] }

  componentDidMount() {
    const url = findApiV4Link({ofObject: this.props.fundraisingEvent, withRel: 'forwardings'})
    JSONFetcher.load({ url: url, success: response => this.setState(response)})
  }

  render() {
    const sumForwardedCents = this.state.data.reduce((acc, curr) => acc + curr.forwarded_amount_in_cents, 0)
    const forwardingLines = this.state.data.map((forwarding, i) => <Forwarding {...forwarding} key={i} />)

    return <div className="fundraising-events-show-forwardings has-generic-scroll-down-button center-block" id='forwardings'>
      <div style={{minHeight: 130}}>
        <div className="container">
          <div className="row fundraising-events-forwardings-index">
            <div className="col-md-16 offset-md-4 text-center">
              <h1 className="font-lg">{I18n.t('fundraising_events.forwardings.index.headline')}</h1>
              <h2 className="font-sm">{I18n.t('fundraising_events.forwardings.index.introduction_html')}</h2>
            </div>
            <div className="col-md-14 offset-md-5">
              <table className="table generic-calculation-table fundraising-events-forwarding-summary-table">
                <tbody>
                  {forwardingLines}
                  <ForwardableAmount contactName={this.props.fundraisingEvent.contact.name} cents={this.props.fundraisingEvent.donated_amount_in_cents - sumForwardedCents} />
                  <Sum cents={this.props.fundraisingEvent.donated_amount_in_cents} />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <a className="generic-scroll-down-button" onClick={(event) => {
        event.preventDefault()
        gaEvent('engagement', 'click down_arrow', 'from forwarding summary to footer')
        document.querySelector('#share').scrollIntoView({behavior: 'smooth'})
      }} href="#share" />
    </div>
  }
}

const Forwarding = (props) => {
  const projectUrl = findApiV4Link({ofObject: props, withRel: 'platform'})
  const title = projectUrl ? <a href={projectUrl} dangerouslySetInnerHTML={{ __html: props.title }} /> : <strong dangerouslySetInnerHTML={{ __html: props.title }} />
  const formattedAmount = formatCents(props.forwarded_amount_in_cents)
  let amount = <strong>{formattedAmount}</strong>
  if (props.forwarded_amount_in_cents === 0) {
    amount = <span>{I18n.t('fundraising_events.forwardings.index.zero_prefix_label')} {formattedAmount}</span>
  }

  return <tr>
    <td>{title}</td>
    <td className="amount">{amount}</td>
  </tr>
}

const ForwardableAmount = ({cents, contactName}) => {
  if (cents === 0) return null
  return <tr>
    <td>{I18n.t('fundraising_events.forwardings.index.not_forwarded_label', {manager_name: contactName})}</td>
    <td className="amount"><strong>{formatCents(cents)}</strong></td>
  </tr>
}

const Sum = ({cents}) => {
  return <tr className="sum">
    <td><strong>{I18n.t('fundraising_events.forwardings.index.sum_of_donations_label')}</strong></td>
    <td className="amount"><strong>{formatCents(cents)}</strong></td>
  </tr>
}
